var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.748 2.747c2.271 0 4.405.884 6.011 2.489l24.506 24.506a8.52 8.52 0 0 1 2.479 6.255 8.527 8.527 0 0 1-2.479 6.261L29.758 66.764a8.443 8.443 0 0 1-6.01 2.489 8.443 8.443 0 0 1-6.01-2.489c-3.314-3.314-3.314-8.707 0-12.021L36.481 36 17.738 17.258c-3.314-3.314-3.314-8.707 0-12.021a8.443 8.443 0 0 1 6.01-2.49zm0 62.506a4.474 4.474 0 0 0 3.182-1.317L50.963 39.43c.891-.893.833-2.084.833-3.355v-.151c0-1.271.058-2.461-.833-3.353L26.693 8.064c-.85-.85-1.862-1.317-3.063-1.317-1.203 0-2.273.468-3.123 1.317-1.755 1.755-1.725 4.61.03 6.365l20.172 20.156a2 2 0 0 1 .007 2.828L20.563 57.57a4.507 4.507 0 0 0 .001 6.365 4.473 4.473 0 0 0 3.184 1.318z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.fb43b347.svg";
export { ForwardRef as ReactComponent };